import React, { useState } from "react";

import "./my-projects.css";

import "react-responsive-modal/styles.css";
import Breadcrumbs from "../layout/breadcrumb";

function MyProjects() {
  return (
    <>
      <Breadcrumbs
        title="Project Details"
        menu="My Projects"
        link="Project Details"
      />
      <div className="p-5">My Projects</div>
    </>
  );
}

export default MyProjects;
